/* SES Palma · agradecimiento de temporada SS26 en el portal de mayoristas.
   Lo decide el servidor (portal_register_login): todo comprador con empresa activa, en sesión nueva y las 3 primeras veces.
   Vista previa para administradores: ?gracias=1. Si algo falla no se muestra nada (falla cerrado, sin errores). */
(function () {
  'use strict';
  const B = window.SESB2B;
  if (!B) return;
  const { esc, ICON, t } = B;

  B.extend({
    gr_eyebrow: { es: 'Temporada SS26', en: 'SS26 season', fr: 'Saison SS26', it: 'Stagione SS26' },
    gr_title:   { es: 'Gracias, {name}', en: 'Thank you, {name}', fr: 'Merci, {name}', it: 'Grazie, {name}' },
    gr_title_0: { es: 'Gracias', en: 'Thank you', fr: 'Merci', it: 'Grazie' },
    gr_p1: {
      es: 'Cerramos SS26, una temporada especial para SES. Gracias por tu confianza y por cada conversación.',
      en: 'SS26 has come to a close, and it was a special season for SES. Thank you for your trust and for every conversation.',
      fr: 'SS26 s\'achève, une saison particulière pour SES. Merci pour votre confiance et pour chacun de nos échanges.',
      it: 'Chiudiamo SS26, una stagione speciale per SES. Grazie per la fiducia e per ogni conversazione.',
    },
    gr_p2: {
      es: 'SS27 ya está aquí, con nuevas piezas pensadas para el verano mediterráneo. Nos encantaría verlas también en tu tienda.',
      en: 'SS27 is here, with new pieces made for the Mediterranean summer. We would love to see them in your store too.',
      fr: 'SS27 est arrivée, avec de nouvelles pièces pensées pour l\'été méditerranéen. Nous serions ravis de les voir aussi dans votre boutique.',
      it: 'SS27 è arrivata, con nuovi capi pensati per l\'estate mediterranea. Ci piacerebbe vederli anche nel tuo negozio.',
    },
    gr_sign:    { es: 'Un abrazo,', en: 'Warmly,', fr: 'Bien à vous,', it: 'Un abbraccio,' },
    gr_cta:     { es: 'Ver la colección SS27', en: 'View the SS27 collection', fr: 'Découvrir la collection SS27', it: 'Scopri la collezione SS27' },
    gr_alt:     { es: 'Dos hombres con prendas SES en el muelle de Cala Figuera, Mallorca', en: 'Two men wearing SES on the quay at Cala Figuera, Mallorca', fr: 'Deux hommes en SES sur le quai de Cala Figuera, Majorque', it: 'Due uomini con capi SES sul molo di Cala Figuera, Maiorca' },
  });

  let checkedSession = null;
  let open = false;

  function previewRequested() {
    try { return new URLSearchParams(location.search).get('gracias') === '1'; } catch (_) { return false; }
  }

  // ctx: { session, me, company, root, orderUrl }. Se llama tras pintar el portal (sesión cargada).
  async function check(ctx) {
    const c = ctx || {};
    const canShow = () => !c.canShow || c.canShow();
    if (!c.session || !c.session.access_token || open || !canShow()) return;
    const preview = previewRequested() && !!(c.me && c.me.is_admin);
    if (checkedSession === c.session.access_token && !preview) return;
    checkedSession = c.session.access_token;
    let res = null;
    try {
      const r = await B.rpc('portal_register_login');
      res = r && !r.error ? r.data : null;
    } catch (_) { res = null; }
    if (!canShow()) { checkedSession = null; return; }
    if (!preview && !(res && res.show === true)) return;
    const eligible = (res && Array.isArray(res.companies)) ? res.companies : [];
    // el nombre de la empresa activa; si no hay ninguna elegida, la primera del comprador
    const active = c.company && eligible.find((x) => x.id === c.company.id);
    const name = (active || eligible[0] || (preview && c.company) || {}).name || '';
    const published = B.publishedSettings ? await B.publishedSettings() : null;
    if (published && published.welcome_image && /^https:\/\//i.test(published.welcome_image)) {
      window.SES_B2B_CONFIG = Object.assign({}, window.SES_B2B_CONFIG || {}, { graciasImg: { src: published.welcome_image } });
    }
    await preload();
    if (!canShow()) { checkedSession = null; return; }
    show({ name, root: c.root, orderUrl: c.orderUrl, settings: published });
  }

  const SIZES = '(min-width: 760px) 440px, 100vw';
  // Descarga y descodifica la foto antes de abrir, para que el popup no aparezca con el hueco vacío.
  // Como mucho 1,5 s: si tarda más, se abre igual y la foto entra cuando llegue.
  function preload() {
    const img = (window.SES_B2B_CONFIG || {}).graciasImg || {};
    if (!img.src) return Promise.resolve();
    const im = new Image();
    im.sizes = SIZES;
    if (img.srcset) im.srcset = img.srcset;
    im.src = img.src;
    const ready = im.decode ? im.decode().catch(() => {}) : new Promise((r) => { im.onload = im.onerror = r; });
    return Promise.race([ready, new Promise((r) => setTimeout(r, 1500))]);
  }

  function show(o) {
    if (open) return;
    open = true;
    const tr = (key) => t(key, { name: o.name || '', company: o.name || '', link: o.orderUrl || '/pages/venta-wholesale', booking_url: (o.settings || {}).booking_url || '' });
    const root = o.root || document.querySelector('.ses-b2b') || document.body;
    const prev = document.activeElement;
    const titleId = 'grT' + Math.random().toString(36).slice(2, 7);
    const descId = titleId + 'd';
    const cfg = window.SES_B2B_CONFIG || {};
    const img = cfg.graciasImg || {};
    const wrap = document.createElement('div');
    wrap.className = 'gr-wrap';
    wrap.innerHTML = `
      <div class="gr-dialog" role="dialog" aria-modal="true" aria-labelledby="${titleId}" aria-describedby="${descId}">
          <button type="button" class="gr-close" data-close aria-label="${esc(t('close'))}">${ICON.close}</button>
        <figure class="gr-photo">
          ${img.src ? `<img src="${esc(img.src)}"${img.srcset ? ` srcset="${esc(img.srcset)}" sizes="${SIZES}"` : ''}
            width="800" height="1200" alt="${esc(tr('gr_alt'))}">` : ''}
        </figure>
        <div class="gr-body">
          <p class="gr-eyebrow">${esc(tr('gr_eyebrow'))}</p>
          <span class="gr-rule" aria-hidden="true"></span>
          <h2 class="gr-title" id="${titleId}" tabindex="-1">${esc(o.name ? tr('gr_title') : tr('gr_title_0'))}</h2>
          <div class="gr-text" id="${descId}">
            <p>${esc(tr('gr_p1'))}</p>
            <p>${esc(tr('gr_p2'))}</p>
          </div>
          <p class="gr-sign"><span>${esc(tr('gr_sign'))}</span><span class="gr-sign-name">Antonio</span><span class="gr-sign-house">SES Palma</span></p>
          <a class="b2b-btn b2b-btn--primary gr-cta" href="${esc(o.orderUrl || '/pages/venta-wholesale')}">${esc(tr('gr_cta'))}</a>
        </div>
      </div>`;
    root.appendChild(wrap);
    B.lockScroll(true);
    let release = null;
    function close() {
      if (!open) return;
      open = false;
      if (release) release();
      B.lockScroll(false);
      wrap.classList.add('is-leaving');
      const gone = () => { wrap.remove(); };
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) gone();
      else setTimeout(gone, 160);
      if (prev && prev.focus && document.contains(prev)) prev.focus({ preventScroll: true });
    }
    release = B.trapFocus(wrap, close);
    wrap.addEventListener('click', (e) => {
      if (e.target === wrap || e.target.closest('[data-close]')) close();
    });
    // el enlace navega; si es la misma página (hash), se cierra igualmente
    wrap.querySelector('.gr-cta').addEventListener('click', () => close());
    requestAnimationFrame(() => wrap.classList.add('is-open'));
    wrap.querySelector('.gr-title').focus({ preventScroll: true });
  }

  window.SESGracias = { check, show: async (o) => { await preload(); show(o); } };
})();
